import { useState, useEffect} from "react";
import LoginForm from "./loginForm";
import Contenido from "./contenido";
import axios from "axios";
import { Image } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

function App() {
  const [logged, setLogged] = useState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState(JSON.parse(sessionStorage.getItem('user')) || null);
  const [idUserSelected, setIdUserSelected] = useState(0)
  const [usuarioImagen, setUsuarioImagen] = useState();
  //const apiUrl = "http://54.183.60.156:3011";
  //const apiUrl = `http://${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}`;
  const apiUrl = `${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}`;
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedContent, setSelectedContent] = useState(null);
  const [showModalCode, setShowModalCode] = useState(false);
  const [codigo, setCodigo] = useState('');

  const iniciarSesion = () => {
    axios.post(`${apiUrl}/login`, {Email: email, Pass: password})
      .then((objResponse) => {
        if(objResponse.data.response.usuario[0].ActualizaPassword === true) {
          alert(`Se ha hecho un reseteo de contraseña, debe actualizarla.`);
          setIdUserSelected(objResponse.data.response.usuario[0].IDUSUARIO);
          sessionStorage.setItem('token', objResponse.data.response.token);
          setShowModal(true);
          return;
        }
        const fCaducaPassword = new Date(objResponse.data.response.usuario[0].FCaducaPassword);
        const fechaActual = new Date();
        if(fCaducaPassword<fechaActual) {
          alert(`Por seguridad es necesario cambiar tu contraseña periodicamente.`);
          setIdUserSelected(objResponse.data.response.usuario[0].IDUSUARIO);
          sessionStorage.setItem('token', objResponse.data.response.token);
          setShowModal(true);
          return;
        }
        setShowModalCode(true);
        sessionStorage.setItem('token', objResponse.data.response.token);
      })
      .catch((error) => {
        alert('hubo un error: ' + error.response.data.mensaje)
      });
  }
  
  const cerrarSesion = () => {
    setUser(null);
    setLogged(false);
    setSelectedContent(null);
    setSelectedOption("");
    setPassword("");
    sessionStorage.removeItem('token');
  }

  const comparaCodigo = () => {
    axios.post(`${apiUrl}/usuario/valida?token=${sessionStorage.getItem('token')}`, 
      {
        LOGIN: email,
        Pass: password,
        code: codigo
      })
      .then((objResponse)=>{
        setUser(objResponse.data.response.usuario[0]);
        setLogged(true);
        sessionStorage.setItem('token', objResponse.data.response.token);
        setUsuarioImagen(<Image thumbnail src={objResponse.data.response.usuario[0].UrlPhoto} style={{width:"2em", height: "2em"}}/>)
        setCodigo('')
        setShowModalCode(false)
      })
      .catch((error)=>{
        alert('hubo un error: ' + error.response.data.mensaje)
      })
  }

  return (
    <div>
      <Modal show={showModalCode}>
        <Modal.Header closeButton>
            <Modal.Title>Introduce el código</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control 
            type="number"
            value={codigo}
            onChange={(e)=>{
              setCodigo(e.target.value)
            }}
          />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={()=>{setShowModalCode(false)}}>Close</Button>
            <Button 
                variant="primary" 
                onClick={comparaCodigo}
            >Enviar código</Button>
        </Modal.Footer>
      </Modal>
      {
        (logged) ? 
          <Contenido 
            userParam={user} 
            cerrarSesionParam={cerrarSesion}
            apiUrl={apiUrl}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            selectedContent={selectedContent}
            setSelectedContent={setSelectedContent}
          />
          :
          <LoginForm 
            iniciarSesionParam={iniciarSesion}
            email = {email} 
            setEmail = {setEmail} 
            password = {password} 
            setPassword = {setPassword}
            showModal={showModal}
            setShowModal={setShowModal}
            apiUrl={apiUrl}
            idUserSelected={idUserSelected}
          />
      }
    </div>
    
  );
}

export default App;
